import { alignment, defaultDataType } from 'export-xlsx';

// Export settings
export const SETTINGS_FOR_EXPORT = {
  // Table settings
  fileName: 'example',
  workSheets: [
    {
      sheetName: 'Hoja 1',
      startingRowNumber: 1,
      gapBetweenTwoTables: 2,
      tableSettings: {
        data: {
          importable: true,
          headerGroups: [
            {
              name: 'Score',
              key: 'score',
            },
          ],
          headerDefinition:
            [
              {
                name: 'Fecha',
                key: 'Fecha',
                width: 20,
              },
              {
                name: 'Técnico',
                key: 'Tecnico',
                width: 20,
              },
              {
                name: 'Receptor',
                key: 'Receptor',
                width: 20,
              },
              {
                name: 'Voltaje',
                key: 'Voltaje',
                width: 20,
              }
            ]
        }
      }
    }
  ]
};